import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomFieldDefinition } from '../../../models/custom-field.model';
import { isPropertyModifiedInList, getPreviousStepOldValue as lookupPreviousStepOldValue } from '../../../utilities/previous-step-changes.util';

@Component({
  selector: 'app-dynamic-fields-section',
  templateUrl: './dynamic-fields-section.component.html',
  styleUrls: ['./dynamic-fields-section.component.scss']
})
export class DynamicFieldsSectionComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() customFields$!: Observable<CustomFieldDefinition[]>;
  @Input() modifiedPropertyNames: string[] = [];
  @Input() modifiedPropertyOldValues: Record<string, string> = {};
  @Input() showChangesHighlight = false;

  ngOnInit(): void {
  }

  isFieldModified(fieldName: string): boolean {
    return (
      isPropertyModifiedInList(
        this.modifiedPropertyNames,
        this.showChangesHighlight,
        fieldName
      ) ||
      isPropertyModifiedInList(
        this.modifiedPropertyNames,
        this.showChangesHighlight,
        `cf_${fieldName}`
      )
    );
  }

  getPreviousStepOldValue(fieldName: string): string | null {
    return (
      lookupPreviousStepOldValue(
        this.modifiedPropertyOldValues,
        this.showChangesHighlight,
        fieldName
      ) ||
      lookupPreviousStepOldValue(
        this.modifiedPropertyOldValues,
        this.showChangesHighlight,
        `cf_${fieldName}`
      )
    );
  }

  getFieldControl(fieldName: string): FormControl<any> | null {
    const control = this.formGroup.get(fieldName);
    return control instanceof FormControl ? control : null;
  }
}
